'use client';

import React from 'react';
import Image from 'next/image';

interface RatingBarProps {
  rating: number;
  maxRating?: number;
  className?: string;
}

const RatingBar: React.FC<RatingBarProps> = ({ rating, maxRating = 1, className = '' }) => {
  return (
    <div data-component-id="src/components/ui/RatingBar.tsx:14:4" data-component-path="src/components/ui/RatingBar.tsx" data-component-line="14" data-component-file="RatingBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`flex items-center space-x-1 ${className}`}>
      {Array.from({ length: maxRating }, (_, index) => (
        <Image data-component-id="src/components/ui/RatingBar.tsx:16:8" data-component-path="src/components/ui/RatingBar.tsx" data-component-line="16" data-component-file="RatingBar.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22w-%5B74px%5D%20h-3.5%22%7D"
          key={index}
          src={index < rating ? '/images/img_rate.svg' : '/images/img_rate_blue_gray_500_02.svg'}
          alt={`Star ${index + 1}`}
          width={78}
          height={14}
          className="w-[74px] h-3.5"
        />
      ))}
    </div>
  );
};

export default RatingBar;
